<template>
  <el-dialog :title="title" :visible.sync="isVisible" @close="onClose">
    <!--Formulario para edicion de Ordenes de compra-->
    <el-form
      v-if="!isEditOrderLine"
      :model="editOrderBuyForm"
      :rules="rules"
      :ref="formName"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-row>
        <el-col :span="10">
          <el-form-item label="No. de Compra:" prop="order">
            <el-input
              v-model="editOrderBuyForm.order"
              :disabled="true"
            ></el-input>
          </el-form-item>

          <el-form-item label="Estado:" prop="estate">
            <el-select
              v-model="editOrderBuyForm.estate"
              placeholder="Cambiar Estado"
            >
              <el-option
                v-for="item in OrderBuyStates"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Estado:" prop="OStatus">
            <el-select
              v-model="editOrderBuyForm.OStatus"
              placeholder="Cambiar Estado de Orden"
            >
              <el-option
                v-for="item in OrderBuyOStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11" :offset="1">
          <el-form-item label="Nombre de compra:" prop="orderName">
            <el-input
              v-model="editOrderBuyForm.orderName"
              :disabled="true"
            ></el-input>
          </el-form-item>

          <el-form-item label="Monto:" prop="orderAmount">
            <el-input
              v-model="editOrderBuyForm.orderAmount"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!--
        <el-form-item label="Activity time" required>
            <el-col :span="11">
            <el-form-item prop="date1">
                <el-date-picker type="date" placeholder="Pick a date" v-model="editOrderBuyForm.date1" style="width: 100%;"></el-date-picker>
            </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
            <el-form-item prop="date2">
                <el-time-picker placeholder="Pick a time" v-model="editOrderBuyForm.date2" style="width: 100%;"></el-time-picker>
            </el-form-item>
            </el-col>
        </el-form-item>
        <el-form-item label="Instant delivery" prop="delivery">
            <el-switch v-model="editOrderBuyForm.delivery"></el-switch>
        </el-form-item>
        <el-form-item label="Activity type" prop="type">
            <el-checkbox-group v-model="editOrderBuyForm.type">
            <el-checkbox label="Online activities" name="type"></el-checkbox>
            <el-checkbox label="Promotion activities" name="type"></el-checkbox>
            <el-checkbox label="Offline activities" name="type"></el-checkbox>
            <el-checkbox label="Simple brand exposure" name="type"></el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="Resources" prop="resource">
            <el-radio-group v-model="editOrderBuyForm.resource">
            <el-radio label="Sponsorship"></el-radio>
            <el-radio label="Venue"></el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="Activity form" prop="desc">
            <el-input type="textarea" v-model="editOrderBuyForm.desc"></el-input>
        </el-form-item>
        
        <el-form-item >
            <el-button type="primary" @click="submitForm('editOrderBuyForm')">Create</el-button>
            <el-button @click="resetForm('editOrderBuyForm')">Reset</el-button>
        </el-form-item>
        -->
    </el-form>
    <!--Formulario para edicion de lineas de compra-->
    <el-form
      v-else
      :model="editOrderLineForm"
      :rules="LineformRules"
      :ref="formName"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-row>
        <el-col :span="10">
          <el-form-item label="No. de Linea" prop="lineOrder">
            <el-input
              v-model="editOrderLineForm.lineOrder"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="Descripcion" prop="description">
            <el-input
              v-model="editOrderLineForm.description"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="Cantidad" prop="qty">
            <el-input v-model="editOrderLineForm.qty"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11" :offset="1">
          <el-form-item label="No. de Orden" prop="orderNo">
            <el-input
              v-model="editOrderLineForm.orderNo"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="No. de Proveedor" prop="vendorNo">
            <el-input
              v-model="editOrderLineForm.vendorNo"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="Monto" prop="amount">
            <el-input v-model="editOrderLineForm.amount"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!--
  <el-form-item label="Activity zone" prop="region">
    <el-select v-model="editOrderLineForm.region" placeholder="Activity zone">
      <el-option label="Zone one" value="shanghai"></el-option>
      <el-option label="Zone two" value="beijing"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="Activity time" required>
    <el-col :span="11">
      <el-form-item prop="date1">
        <el-date-picker type="date" placeholder="Pick a date" v-model="editOrderLineForm.date1" style="width: 100%;"></el-date-picker>
      </el-form-item>
    </el-col>
    <el-col class="line" :span="2">-</el-col>
    <el-col :span="11">
      <el-form-item prop="date2">
        <el-time-picker placeholder="Pick a time" v-model="editOrderLineForm.date2" style="width: 100%;"></el-time-picker>
      </el-form-item>
    </el-col>
  </el-form-item>
  <el-form-item label="Instant delivery" prop="delivery">
    <el-switch v-model="editOrderLineForm.delivery"></el-switch>
  </el-form-item>
  <el-form-item label="Activity type" prop="type">
    <el-checkbox-group v-model="editOrderLineForm.type">
      <el-checkbox label="Online activities" name="type"></el-checkbox>
      <el-checkbox label="Promotion activities" name="type"></el-checkbox>
      <el-checkbox label="Offline activities" name="type"></el-checkbox>
      <el-checkbox label="Simple brand exposure" name="type"></el-checkbox>
    </el-checkbox-group>
  </el-form-item>
  <el-form-item label="Resources" prop="resource">
    <el-radio-group v-model="editOrderLineForm.resource">
      <el-radio label="Sponsorship"></el-radio>
      <el-radio label="Venue"></el-radio>
    </el-radio-group>
  </el-form-item>
  <el-form-item label="Activity form" prop="desc">
    <el-input type="textarea" v-model="editOrderLineForm.desc"></el-input>
  </el-form-item>
  -->
      <!--
  <el-form-item>
    <el-button type="primary" @click="submitForm('editOrderLineForm')">Create</el-button>
    <el-button @click="resetForm('editOrderLineForm')">Reset</el-button>
  </el-form-item>
  -->
    </el-form>
    <div slot="footer" class="dialog-footer" type="flex" justify="end">
      <el-button type="primary" @click="submitForm(formName)">Editar</el-button>
      <el-button @click="resetForm(formName)">Cancelar</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "editOrderBuy",
  props: {
    editOrderVisible: {
      type: Boolean,
      default: false
    },
    editOrderBuy: {
      type: Boolean,
      default: false
    },
    isEditOrderLine: {
      type: Boolean,
      default: false
    },
    orderData: {
      type: Object,
      default: () => {}
    }
  },
  data: function () {
    return {
      title: "Editar Orden de compra",
      editOrderBuyForm: {
        order: "",
        orderName: "",
        orderAmount: "",
        estate: "",
        OStatus: ""
        /*
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                    */
      },
      rules: {
        order: [
          {
            required: true,
            message: "Please input Activity name",
            trigger: "blur"
          }
          //{ min: 3, max: 5, message: "Length should be 3 to 5", trigger: "blur" },
        ],

        estate: [
          {
            required: true,
            message: "Please select Activity zone",
            trigger: "blur"
          }
        ]
        /*
                    date1: [
                        { type: 'date', required: true, message: 'Please pick a date', trigger: 'change' }
                    ],
                    date2: [
                        { type: 'date', required: true, message: 'Please pick a time', trigger: 'change' }
                    ],
                    type: [
                        { type: 'array', required: true, message: 'Please select at least one activity type', trigger: 'change' }
                    ],
                    resource: [
                        { required: true, message: 'Please select activity resource', trigger: 'change' }
                    ],
                    desc: [
                        { required: true, message: 'Please input activity form', trigger: 'blur' }
                    ]
                    */
      },
      OrderBuyStates: [
        {
          value: 0,
          label: "Abierto"
        },
        {
          value: 1,
          label: "Lanzado"
        },
        {
          value: 2,
          label: "Aprobación pendiente"
        },
        {
          value: 3,
          label: "Anticipo pendiente"
        }
      ],
      OrderBuyOStatus: [
        {
          value: 0,
          label: " "
        },
        {
          value: 1,
          label: "En Fabrica"
        },
        {
          value: 2,
          label: "En Tránsito"
        },
        {
          value: 3,
          label: "En Aduana"
        },
        {
          value: 4,
          label: "Magycorp"
        },
        {
          value: 5,
          label: "Despachado Cliente"
        },
        {
          value: 6,
          label: "Entregado"
        },
        {
          value: 7,
          label: "Pendiente de Pago"
        }
      ],
      editOrderLineForm: {
        orderNo: "",
        lineOrder: "",
        description: "",
        vendorNo: "",
        qty: "",
        amount: ""

        /*
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
          */
      },
      LineformRules: {
        orderNo: [
          {
            required: true,
            message: "Please input Activity name",
            trigger: "blur"
          }
          //{ min: 3, max: 5, message: "Length should be 3 to 5", trigger: "blur" },
        ],
        qty: [
          {
            required: true,
            message: "Please input Activity name",
            trigger: "blur"
          }
          //{ min: 3, max: 5, message: "Length should be 3 to 5", trigger: "blur" },
        ],
        amount: [
          {
            required: true,
            message: "Please input Activity name",
            trigger: "blur"
          }
          //{ min: 3, max: 5, message: "Length should be 3 to 5", trigger: "blur" },
        ]
        /*
          region: [
            { required: true, message: 'Please select Activity zone', trigger: 'change' }
          ],
          date1: [
            { type: 'date', required: true, message: 'Please pick a date', trigger: 'change' }
          ],
          date2: [
            { type: 'date', required: true, message: 'Please pick a time', trigger: 'change' }
          ],
          type: [
            { type: 'array', required: true, message: 'Please select at least one activity type', trigger: 'change' }
          ],
          resource: [
            { required: true, message: 'Please select activity resource', trigger: 'change' }
          ],
          desc: [
            { required: true, message: 'Please input activity form', trigger: 'blur' }
          ]
          */
      }
    };
  },
  computed: {
    isVisible: function () {
      return this.editOrderVisible;
    },
    formName: function () {
      let name = "";

      if (!this.isEditOrderLine) {
        name = "editOrderBuyForm";
      } else {
        name = "editOrderLineForm";
      }

      return name;
    }
  },
  methods: {
    onClose: function () {
      this.isVisible = false;
      this.$emit("onCloseOrderEdit", false);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //alert("submit!");

          if (!this.isEditOrderLine) {
            const params = {
              No: this.orderData.No,
              Stat: this.editOrderBuyForm.estate,
              OStatus: this.editOrderBuyForm.OStatus
            };
            this.$http
              .put("/api/invoices/EditOrderBuy", params)
              .then((resp) => {
                //console.log("did it: ", resp);
                resp;
                this.$emit(
                  "onOrderEdited",
                  this.isEditOrderLine,
                  this.orderData.No
                );
                this.$refs[formName].resetFields();
                this.isVisible = false;
              });
          } else {
            const params = {
              Document_No_: this.editOrderLineForm.orderNo,
              Line_No_: this.editOrderLineForm.lineOrder,
              Quantity: this.editOrderLineForm.qty,
              Outstanding_Amount: this.editOrderLineForm.amount
            };
            this.$http
              .put("/api/invoices/EditOrderLine", params)
              .then((resp) => {
                //console.log("did it: ", resp);
                resp;
                this.$emit(
                  "onOrderEdited",
                  this.isEditOrderLine,
                  this.orderData.DocumentNo
                );
                this.$refs[formName].resetFields();
                this.isVisible = false;
              });
          }
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.isVisible = false;
      this.$emit("onCloseOrderEdit", false);
    }
  },
  watch: {
    isVisible(val) {
      if (val == true) {
        if (!this.isEditOrderLine) {
          this.editOrderBuyForm.order = this.orderData.No;
          this.editOrderBuyForm.orderName = this.orderData.BuyName;
          this.editOrderBuyForm.orderAmount = this.orderData.InvoiceCost;
          this.editOrderBuyForm.OStatus = this.orderData.OStatus;
          this.editOrderBuyForm.estate = this.orderData.Stat;
        } else {
          this.editOrderLineForm.orderNo = this.orderData.DocumentNo;
          this.editOrderLineForm.lineOrder = this.orderData.LineNo;
          this.editOrderLineForm.description = this.orderData.Description;
          this.editOrderLineForm.vendorNo = this.orderData.NoBuy;
          this.editOrderLineForm.qty = this.orderData.Quantity;
          this.editOrderLineForm.amount = this.orderData.Amount;
        }
      }
    }
  }
};
</script>

<style></style>
